import React, { useContext } from 'react';
import Row from 'react-bootstrap/Row';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { OverviewContext } from '../../context/OverviewProvider';
import { LabelText } from '../../../components/Language';
import Aux from '../../../hoc/Auxiliary';
import HeaderTitle from '../../../hoc/HeaderTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import './index.css';

export default function OverviewHeader(props) {
    const { isOverviewFilterApplied, handlerOnClearFilterClick }
        = useContext(OverviewContext);

    const clearFilterTooltip = (
        <Tooltip id="clearFilterIcon">
            <LabelText tid={isOverviewFilterApplied ? "clearfilter" : "inactivefilter"} />
        </Tooltip>
    )

    return (
        <Aux>
            <div className="Overview-header-main">
                <HeaderTitle className="OverviewDetail-header-col row">
                    <span className="Title-align">
                        <LabelText tid={"Overview"} />
                    </span>
                </HeaderTitle>
                {/* <Row className="Overview-btn-row" style={{ width: '100% !important' }}>
                    <div className="empty-div" />
                    <OverlayTrigger placement="bottom" overlay={clearFilterTooltip}>
                        <div role="button" tabIndex="0" >
                            <FontAwesomeIcon className="FilterButton" icon={faFilter} />
                        </div>
                    </OverlayTrigger>
                </Row> */}
                <Row className="Overview-btn-row" style = {{width: '100% !important'}}>
                    <div className="empty-div"/>
                        <OverlayTrigger placement="top" overlay={clearFilterTooltip}>
                            <div role="button" tabIndex="0" 
                                title= {isOverviewFilterApplied ? "Clear filter" : "Inactive Filter"}              
                                disabled={!props.isOverviewDataAvailable}
                                onClick={()=>isOverviewFilterApplied && handlerOnClearFilterClick(true, true)}
                                onKeyDown={(e) => { e.key === "Enter" 
                                && isOverviewFilterApplied && handlerOnClearFilterClick(true, true)}} >
                                <FontAwesomeIcon className = { props.isOverviewDataAvailable ?
                                    isOverviewFilterApplied ? "FilterButton ActiveFilterButton" 
                                    : "FilterButton InActiveFilterButton"
                                    : "FilterButton InActiveFilterButton disable-icon" } icon= {faFilter} />
                            </div>
                        </OverlayTrigger> 
                    {/* <OverlayTrigger placement="top" overlay={clearFilterTooltip}>
                    <div role="button" style={{margin: ".9vw .2vw .9vw .2vw"}} tabIndex="0" 
                            title={isOverviewFilterApplied ? "Clear filter" : "Inactive Filter"}
                            className={(isOverviewFilterApplied ? "ActiveFilterButton" : "InActiveFilterButton")}
                            onClick={() => isOverviewFilterApplied && handlerOnClearFilterClick(true, true)}
                            onKeyDown={(e) => { e.key === "Enter" && isOverviewFilterApplied && handlerOnClearFilterClick(true, true) }}
                    />
                </OverlayTrigger> */}
                </Row> 
            </div>
        </Aux>
    );
}


